import glFetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import EnterpriseApiRoutes from "common/ApiRoutes";
export const fetchEventProcedures = async (page, perPage, query = null, orderBy = void 0, direction = void 0) => {
  const params = [`page=${page}`, `per_page=${perPage}`];
  if (query) params.push(`query=${encodeURI(query)}`);
  if (orderBy) {
    params.push(`sort=${orderBy}`);
  }
  if (direction) {
    params.push(`direction=${direction}`);
  }
  return glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.index(params.join("&")).url));
};
export const fetchEventProcedure = async (eventProcedureId) => glFetch(
  "GET",
  qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.singleEventProcedure(eventProcedureId).url)
);
export const fetchDecoratedEventProcedure = async (eventProcedureId, eventId) => glFetch(
  "GET",
  qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.decoratedEventProcedure(eventProcedureId, eventId).url)
);
export const createEventProcedure = async (payload) => {
  const { share_request, ...rest } = payload;
  return glFetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.new().url), {
    entity: rest,
    share_request
  });
};
export const updateEventProcedure = async ({
  eventProcedureId,
  eventProcedure
}) => glFetch(
  "PUT",
  qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.singleEventProcedure(eventProcedureId).url),
  eventProcedure
);
export const fetchEventProcedureSteps = async (page, perPage, query = null, orderBy = void 0, direction = void 0) => {
  const params = [`page=${page}`, `per_page=${perPage}`];
  if (query) params.push(`query=${encodeURI(query)}`);
  if (orderBy) {
    params.push(`sort=${orderBy}`);
  }
  if (direction) {
    params.push(`direction=${direction}`);
  }
  return glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.steps.index(params.join("&")).url));
};
export const createEventProcedureStep = async (payload) => {
  const { share_request, ...rest } = payload;
  return glFetch("POST", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.steps.new().url), {
    entity: rest,
    share_request
  });
};
export const updateEventProcedureStep = async ({ stepId, step }) => glFetch(
  "PUT",
  qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.steps.singleEventProcedureStep(stepId).url),
  step
);
export const deleteEventProcedure = async ({ id }) => {
  glFetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.singleEventProcedure(id).url));
};
export const fetchLinkedProcedures = async (stepId) => glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.steps.linkedProcedures(stepId).url));
export const deleteEventProcedureStep = async ({ id }) => {
  glFetch("DELETE", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.steps.singleEventProcedureStep(id).url));
};
export const fetchParametersForView = async (id, type) => glFetch("GET", qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.steps.viewParameter(id, type).url));
